import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIconRetina from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

const locationIcon = L.icon({
    iconUrl: markerIcon,
    iconRetinaUrl: markerIconRetina,
    shadowUrl: markerShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});

export class OsmMap {
    constructor() {
        document.querySelectorAll('.js-osm-map').forEach(container => {
            const button = container.querySelector('.js-osm-map-load');
            button.hidden = false;
            button.addEventListener('click', () => this.load(container), {once: true});
        });
    }

    load(container) {
        const element = container.querySelector('.block-osm-map');
        const placeholder = container.querySelector('.block-osm-map__placeholder');
        const error = container.querySelector('.block-osm-map__error');
        const {latitude, longitude, zoom, name, address} = container.dataset;
        const coordinates = [Number(latitude), Number(longitude)];

        placeholder.hidden = true;
        element.hidden = false;
        const map = L.map(element).setView(coordinates, Number(zoom));
        // No external requests are made until the visitor activates this map.
        const tiles = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        });
        tiles.on('tileerror', () => { error.hidden = false; });
        tiles.addTo(map);

        const popup = document.createElement('div');
        const title = document.createElement('strong');
        title.textContent = name;
        popup.append(title, document.createElement('br'), document.createTextNode(address));
        L.marker(coordinates, {icon: locationIcon}).addTo(map).bindPopup(popup).openPopup();
    }
}
